import { FETCH_USER, LOGIN, UPDATE_PASSWORD, UPDATE_USER, REQUEST_PASSWORD_RESET, CONFIRM_PASSWORD_RESET } from '@/utils/store/actionTypes'
import { SET_AUTH_TOKEN, SET_AUTH_USER } from '@/utils/store/mutationTypes'
import { apolloClient } from '@/utils/store'
import AuthMe from '@/apollo/auth_user/AuthMe.graphql'
import { formatData } from '@/utils/apollo'
import UpdateAuthUser from '@/apollo/auth_user/UpdateAuthUser.graphql'
import UpdatePassword from '@/apollo/auth_user/UpdatePassword.graphql'

export default {
  /**
   * Fetches a user
   *
   * @param commit
   * @returns {Promise<any>}
   */
  async [FETCH_USER] ({ commit }) {
    const response = await apolloClient(this).query({
      query: AuthMe,
      fetchPolicy: 'no-cache'
    })

    const data = formatData(response).data

    commit(SET_AUTH_USER, { user: data })

    return data
  },

  /**
   * Update auth user.
   *
   * @param commit
   * @param variables
   * @returns {Promise<*>}
   */
  async [UPDATE_USER] ({ commit }, variables) {
    const response = await apolloClient(this).mutate({
      mutation: UpdateAuthUser,
      variables: {
        isUser: true,
        ...variables
      }
    })

    const updatedData = formatData(response).data

    commit(SET_AUTH_USER, { user: updatedData.authUser })

    return updatedData
  },

  /**
   * Update password.
   *
   * @param _
   * @param variables
   * @returns {Promise<*>}
   */
  async [UPDATE_PASSWORD] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: UpdatePassword,
      variables
    })

    return formatData(response).data
  },

  /**
   * Login
   *
   * @param commit
   * @param username
   * @param password
   */
  async [LOGIN] ({ commit }, { username = '', password = '' }) {
    const response = await this.$axios.$post('/login_check', {
      username,
      password
    })

    commit(SET_AUTH_TOKEN, { token: response.token, expires: response.token_expires_at })

    return response
  },
  async [REQUEST_PASSWORD_RESET] (_, { email }) {
    return await this.$axios.$post(`${process.env.API_URL}/v2/password-reset`, { email })
  },
  async [CONFIRM_PASSWORD_RESET] (_, { token, password, passwordRepeat, _hash }) {
    return await this.$axios.$put(`${process.env.API_URL}/v2/password-reset/${token}?_hash=${encodeURIComponent(_hash)}`, { password, passwordRepeat })
  }
}
